/**
 * Bottom-to-top fill bar drawn behind a week-grid day cell.
 * The color comes from `progress-color.helper.ts` (red→yellow→green→purple) so
 * over-budget days flag immediately. Empty cells render nothing.
 */
import { getProgressColor } from '../../helpers/progress-color.helper';
import { calculateProgressPercentage } from '../../helpers/progress-percentage.helper';

interface WeekGridCellBgProps {
  trackedHours: number;
  bookedHours: number;
}

export function WeekGridCellBg({ trackedHours, bookedHours }: WeekGridCellBgProps) {
  if (trackedHours <= 0 && bookedHours <= 0) return null;

  // Fill height clamps to 100% but the *color* uses the raw ratio so >110% turns red/purple.
  const target = bookedHours > 0 ? bookedHours : trackedHours;
  const rawPct = target > 0 ? trackedHours / target : 0;
  const heightPct = Math.min(1, rawPct) * 100;
  const color = getProgressColor(calculateProgressPercentage(trackedHours, bookedHours));

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      <div
        className="absolute inset-x-0 bottom-0 opacity-35"
        style={{ height: `${heightPct}%`, backgroundColor: color }}
      />
    </div>
  );
}
